import React from 'react'
import ReactDOM from 'react-dom/client'
import { ClinicalSessionProvider } from './providers/ClinicalSessionProvider'
import { BrowserRouter } from 'react-router-dom'
import { I18nextProvider } from 'react-i18next'
import './lib/mxTimezone'
import { setupTelemetry, setupErrorTracking } from './lib/telemetry'
import App from './App'
import i18n from './i18n'
import { initThemeColor } from './lib/theme'
import './index.css'

// Instrument before the first render so document-load is captured.
setupTelemetry()
setupErrorTracking()

// Apply the saved accent color before first paint.
initThemeColor()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <ClinicalSessionProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ClinicalSessionProvider>
    </I18nextProvider>
  </React.StrictMode>,
)
